
/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import { AttributeInputCallback, CallbackType, ConfirmationCallback, FRAuth, FRCallback, FRStep } from '@forgerock/javascript-sdk';

import { RadioButtonGroup } from 'react-hook-form-mui'
import { useForm } from 'react-hook-form';
import { useEffect, useState } from 'react';
import SuccessErrorModal, { MessageType } from '../../modals/SuccessErrorModal';
import FormLayout from '../../layout/form';
import FormSection from '../../01-atoms/FormSection';
import { getPolicyByPolicyID, getUIElementsBasedOnType } from '../../../util/uiHelper';
import { useAppDispatch , useAppSelector } from '../../../redux/hooks';
import { setIsValueChanged } from '../../../redux/watchNavigationSlice';
import { reRenderSelector } from '../../../redux/reRenderSlice';
import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';
import cloneDeep from 'lodash/cloneDeep';
import { Subscription } from 'react-hook-form/dist/utils/createSubject';
import { getTextOutputCallBackByMessageType } from '../../../util/generalUtility';
import CustomFormContainer from '../../layout/CustomFormContainer';
import styles from '../../../styles/FormLayout.module.css';
import { BaseCallBackInterface } from './basInterface';
import { store } from '../../../redux/store';
import { ReactJSXElement } from '@emotion/react/types/jsx-namespace';
import myResStyles from "../../../styles/myResources.module.css";
import modalStyle from '../../../styles/SuccessError.module.css';

const viewableCallBackTypes = ['BooleanAttributeInputCallback', 'StringAttributeInputCallback', 'NumberAttributeInputCallback', 'ValidatedCreatePasswordCallback', 'TermsAndConditionsCallback']

export default function FROutputCallbackBasedView({ step,
  setStep,
  tree,
  messageType,
  setMessageType,
  message, setMessage,
  isAlertOpen,
  setIsAlertOpen,
  backLink,
  uiStage,
  fullWidthSave }: BaseCallBackInterface) {
  const formContext = useForm<{}>({
    defaultValues: {
    }
  })

  const [metaDataMap, setMetaDataMap] = useState(new Map())
  const [dependentViewMap, setDependentViewMap] = useState(new Map());
  const [dependentFieldMap, setDependentFieldMap] = useState(new Map());
  const [dependentFieldValidationMap, setDependentFieldValidationMap] = useState(new Map());
  const [isDisabled, setDisabled] = useState(false);
  const [bottomElement, setBottomElement] = useState<JSX.Element | undefined>()
  const [backBottomElement, setBackBottomElement] = useState<JSX.Element | undefined>()
  const [backLinkElement, setBackLinkElement] = useState<JSX.Element | undefined>()
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { reRender } = useAppSelector(reRenderSelector)
  const dispatch = useAppDispatch();

  const [open, setOpen] = useState<boolean>(false)
  const [messageToSend, setMessageToSend] = useState<JSX.Element>(<></>)

 

  //  ---------------------METHODS-----------------------------------

  const setInitialValues = () => {
    step.callbacks?.forEach(callback => {
      if (viewableCallBackTypes.indexOf(callback.getType()) > -1) {
        const attributeInputCallback = new AttributeInputCallback(callback.payload);
        if (attributeInputCallback.getType() === 'BooleanAttributeInputCallback') {
          if((attributeInputCallback.getName() !== 'CDRegion') && (attributeInputCallback.getName() !== 'dualCitizen')){//we can add specific element names to make it more specific if needed.
            formContext.setValue(attributeInputCallback.getName() as never, (attributeInputCallback.getInputValue() as string) as never, { shouldTouch: true, shouldDirty: true, shouldValidate: false })
          }
        }else if(attributeInputCallback.getType()==='TermsAndConditionsCallback'){
          formContext.setValue(attributeInputCallback.getName() as never,false as never)
        } else {
          //if (attributeInputCallback.getName() !== 'emailDomains') {
            if (typeof attributeInputCallback.getInputValue() === 'string') {
              const data = attributeInputCallback.getInputValue() as string;
              if (data.indexOf('[') === -1) {
                formContext.setValue(attributeInputCallback.getName() as never, attributeInputCallback.getInputValue() as never, { shouldTouch: true, shouldDirty: true, shouldValidate: false })
              } else {
                let dataArray:any[] =[];
                if(data!=='[]'){
                  dataArray = data.replace(/"|]/g,"").replace("[","").split(',')
                }
                formContext.setValue(attributeInputCallback.getName() as never, dataArray as never, { shouldTouch: true, shouldDirty: true, shouldValidate: false })
              }
            }
         // }
        }
      }

    })
    // setting this to true to make validations possible even before clicking the submitt button.
    formContext.control._formState.isSubmitted = true;
  }

  var str2bool = (value:any) => {
    if (value && typeof value === "string") {
         if (value.toLowerCase() === "true") return true;
         if (value.toLowerCase() === "false") return false;
    }
    return value;
 }

  function update(name: any, localDependentViewMap: any) {
    let contextInBoolean = false
    if (typeof formContext.getValues(name as never) === 'boolean'){
      contextInBoolean = formContext.getValues(name as never)
    } else if(typeof formContext.getValues(name as never) === 'string'){
      contextInBoolean = str2bool(formContext.getValues(name as never))
    }
    if(typeof contextInBoolean === 'boolean'){
      if (contextInBoolean !== dependentViewMap.get(dependentFieldMap.get(name)).defaultValue) {
        // if (formContext.getValues(name as never) !== dependentViewMap.get(dependentFieldMap.get(name)).defaultValue) {  
      localDependentViewMap.set(dependentFieldMap.get(name), { currentValue: true, defaultValue: dependentViewMap.get(dependentFieldMap.get(name)).defaultValue });
      } else {
        formContext.setValue(dependentFieldMap.get(name) as never, dependentViewMap.get(dependentFieldMap.get(name)).defaultValue as never)
        localDependentViewMap.set(dependentFieldMap.get(name), { currentValue: false, defaultValue: dependentViewMap.get(dependentFieldMap.get(name)).defaultValue });
      }
    } else if(typeof contextInBoolean === 'string'){
        localDependentViewMap.set(dependentFieldMap.get(name), { currentValue: false, defaultValue: dependentViewMap.get(dependentFieldMap.get(name)).defaultValue });  
      }

    if (dependentFieldMap.has(dependentFieldMap.get(name))) {
      localDependentViewMap = update(dependentFieldMap.get(name), localDependentViewMap);
    }
    return localDependentViewMap;
  }

  useEffect(() => {
    let subscription: Subscription;
    if (dependentViewMap.size) {
      subscription = formContext.watch((value, { name, type }) => {
        if (dependentFieldMap.has(name)) {
          subscription.unsubscribe()
          setDependentViewMap(update(name, cloneDeep(dependentViewMap)));
        }
      });
    }
    return () => { if (!!subscription) subscription.unsubscribe() };
  }, [dependentViewMap]);


  const updateSetDependepentMap = (localMetaDataMap: Map<string, any>) => {
    if (localMetaDataMap.size) {
      let dependentMap = new Map<string, string>();
      let dependentViewMapLocal = new Map<string, any>();
      let dependentValidationMapLocal = new Map<string, any>();
      localMetaDataMap.forEach((value, key) => {
        try {
          if (!!value.dependentName && value.dependentName.length > 0) {
            value.dependentName.forEach((dependentValue: { name: string, defaultValue: any }) => {
              dependentViewMapLocal.set(dependentValue.name, { currentValue: dependentValue.defaultValue, defaultValue: dependentValue.defaultValue })
              dependentMap.set(key, dependentValue.name);
            })
          }
          if (!!value.dependentValidation && value.dependentValidation.length) {
            value.dependentValidation.forEach((dependentValidationValue: { name: string, message: string }) => {
              dependentValidationMapLocal.set(key, dependentValidationValue)
            })

          }
        } catch {
          console.warn("dependent Name in meta deta should be array");
        }
      })
      if (dependentViewMapLocal.size) {
        setDependentViewMap(dependentViewMapLocal);
        setDependentFieldMap(dependentMap);
      }
      setDependentFieldValidationMap(dependentValidationMapLocal);
    }

  }



  useEffect(() => {
    // console.log("uiStage ======>" , uiStage )
    if ( uiStage === "BlockNavigation" ) {
      let subscription: Subscription;
      subscription = formContext.watch((value, { name, type }) => {
        // console.log("Name ==== >>>>",name,"type ==== >>>>",type,"value ==== >>>>",value);
        if ( !store.getState()?.watchNavigation.isValueChanged && type === "change" ) {
          dispatch(setIsValueChanged(true));
        }
      });
      return () => {
        if (!!subscription) subscription.unsubscribe();
      };
    }
  });


  const getPasswordHistoryErrorMessage = () => {
    const validatePasswordCallBacks = step.getCallbacksOfType(CallbackType.ValidatedCreatePasswordCallback);
    if (!!validatePasswordCallBacks && validatePasswordCallBacks.length) {
      validatePasswordCallBacks.forEach((validatePasswordCallBack) => {
        const attributeInputCallback = new AttributeInputCallback(validatePasswordCallBack.payload);
        if (attributeInputCallback.getFailedPolicies().length) {
          attributeInputCallback.getFailedPolicies().forEach((failedPolicy: any) => {
            if (failedPolicy === '{ "policyRequirement": "PASSWORD_HISTORY" }') {
              const errorMessage = getPolicyByPolicyID(attributeInputCallback, "UI-TYPE", 'passwordHistory')
              if (!isEmpty(errorMessage.trim())) {
                setIsAlertOpen(true);
                setMessageType(MessageType.error);
                setMessage(errorMessage);
              }
            }
          })
        }
      })
    }
  }
  useEffect(() => {
    if (!!step) {
      if (step.getCallbacksOfType(CallbackType.MetadataCallback).length) {
        const localMetaDataMap = new Map(Object.entries(JSON.parse(JSON.stringify(step.getCallbackOfType(CallbackType.MetadataCallback)?.getOutputByName("data", {})))))
        updateBottomElement(localMetaDataMap)
        updateBackButtonElement(localMetaDataMap);
      }
    }
  }, [isDisabled]);

  useEffect(() => {
    if (!!step) {
      if (step.getCallbacksOfType(CallbackType.MetadataCallback).length) {
        const localMetaDataMap = new Map(Object.entries(JSON.parse(JSON.stringify(step.getCallbackOfType(CallbackType.MetadataCallback)?.getOutputByName("data", {})))))
        setMetaDataMap(localMetaDataMap);
        updateBottomElement(localMetaDataMap)
        updateBackButtonElement(localMetaDataMap);
        // if(!!backLink){
        //   updateBackLink(backLink);
        // }
        updateSetDependepentMap(localMetaDataMap);
      }
       else if (fullWidthSave) {
        updateSaveElement();
      }
      setInitialValues();
      const errorTextCallBack = getTextOutputCallBackByMessageType(step, '2');
      const infoTextCallBack = getTextOutputCallBackByMessageType(step, '1');
      if (!isNil(errorTextCallBack)) {
        setMessageType(MessageType.error);
        setMessage(errorTextCallBack.getOutputByName('message', ''))
        setIsAlertOpen(true)

      } else if (!isNil(infoTextCallBack)) {
        setMessageType(MessageType.info);
        setMessage(infoTextCallBack.getOutputByName('message', ''))
        setIsAlertOpen(true)
      } else {
        getPasswordHistoryErrorMessage();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step]);

  const outSideDataMap = new Map();

  const populateOutSideFormData = (metaInfoMap: Map<any, JSX.Element[]>) => {
    metaDataMap.get('$OutSideForm')?.forEach((value: {
      header: string, type: string, name: string, prompt: string, isRequired: boolean
      data: [{ name: string, value: string }]
    }) => {
      let uiElement: JSX.Element = (<></>);
      outSideDataMap.set(value.header, value.data);
      switch (value.type) {
        case "yesOrNo":
          uiElement = (
            <div style={{ width: '100%', marginTop: '0px', marginBottom: '16px' }}>
              <div>
                <span dangerouslySetInnerHTML={{ __html: value.prompt }} className={styles.outsideValue}></span>{value.isRequired ? "*" : ""}</div>
              <RadioButtonGroup
                key={value.header}
                name="outSideForm1"
                onChange={(value,) => {
                  const result = value.split('$');
                  if (result[0] === 'yes') {
                    outSideDataMap.get(result[1]).forEach((innerData: { name: never, value: never }) => {
                      formContext.setValue(innerData.name, !!innerData.value ? innerData.value : '' as never)
                      formContext.clearErrors(innerData.name)
                      document.getElementById(innerData.name)?.setAttribute('disabled', '');
                    })
                  } else {
                    outSideDataMap.get(result[1]).forEach((innerData: { name: never, value: never }) => {
                      formContext.setValue(innerData.name, "" as never);
                      document.getElementById(innerData.name)?.removeAttribute('disabled');

                    })
                  }
                }}
                options={[{ id: 'yes$' + value.header, label: 'Yes' },
                { id: 'no$' + value.header, label: 'No' }
                ]}
                row
              />
            </div>
          )
          break;

        default:
          break;
      }
      const mapData: any = metaInfoMap.get(value.header) ? metaInfoMap.get(value?.header) : [];
      mapData?.unshift(uiElement);
      metaInfoMap.set(value?.header, mapData)

    })
  }




  const getUIElements = (step: FRStep) => {
    let finalChildren: JSX.Element[] = [];
    let metaInfoMap: Map<any, JSX.Element[]> = new Map();
    if (!!step) {
      step.callbacks.forEach(callback => {
        if (viewableCallBackTypes.indexOf(callback.getType()) > -1) {
          const attributeInputCallback = new AttributeInputCallback(callback.payload);
          if (attributeInputCallback.getPolicies().length === 0) {
          } else {
            const { children, isGroupPart } = getUIElementsBasedOnType(attributeInputCallback, formContext,metaDataMap.get(attributeInputCallback.getName())?.isDisabled, metaDataMap.get(attributeInputCallback.getName())?.validationValues,metaDataMap.get(attributeInputCallback.getName())?.validSecondaryEmail, metaDataMap.get('terms')?.text, dependentViewMap,metaDataMap);
            // const { children, isGroupPart } = getUIElementsBasedOnType(attributeInputCallback, formContext,isDisabledvalue, metaDataMap.get(attributeInputCallback.getName())?.validationValues, metaDataMap.get('terms')?.text, dependentViewMap);
            if (isGroupPart) {
              finalChildren.push(children);

            } else {
              const attributeName = attributeInputCallback.getType() === CallbackType.TermsAndConditionsCallback ? 'terms' : attributeInputCallback.getName()
              const attributeWiseMapData = metaDataMap.get(attributeName)
              const mapData: any = metaInfoMap.get(attributeWiseMapData?.header) ? metaInfoMap.get(attributeWiseMapData?.header) : [];
              if (attributeWiseMapData?.isHalfWidth) {
                if (dependentViewMap.has(attributeName)) {
                  const isdependentVisible = dependentViewMap.get(attributeName);
                  mapData.push((<>{isdependentVisible && <span key={attributeName + 'halfWidth'} className='halfWidth'>{children}</span>}</>))
                } else {

                  mapData.push((<span key={attributeName + 'halfWidth'} className='halfWidth'>{children}</span>))
                }

              } else {
                if (dependentViewMap.has(attributeName)) {
                  const isDependentVisible = dependentViewMap.get(attributeName).currentValue;
                  if (isDependentVisible)
                    mapData.push(children)
                } else {

                  mapData?.push(children);
                }
              }
              metaInfoMap.set(attributeWiseMapData?.header, mapData)
            }
          }
        } else if (callback.getType() === CallbackType.TermsAndConditionsCallback) {

        }
      })
    }
    populateOutSideFormData(metaInfoMap)
    finalChildren.push((<>{getUIElementsFromMap(metaInfoMap)}</>))

    return finalChildren;
  }


  const getUIElementsFromMap = (metaInfoMap: Map<any, JSX.Element[]>) => {
    let uiElements: JSX.Element[] = [];
    metaInfoMap.forEach((value, key) => {
      if (metaDataMap.get('info$' + key)) {
        uiElements.push((<FormSection key={key} sectionHeader={key} infoData={metaDataMap.get('info$' + key).tooltip}>{value}</FormSection>))
      } else {
        uiElements.push((<FormSection key={key} sectionHeader={key}>{value}</FormSection>))
      }
    });
    return uiElements;

  }

  function fillStep(step: FRStep, data: any): any {
    const fillStep = step;
    data = cleanDataBeforeSubmit(data);
    fillStep.getCallbacksOfType(CallbackType.StringAttributeInputCallback).forEach(callback => {
      const attibuteInputCallback = new AttributeInputCallback(callback.payload);
      if (typeof data[attibuteInputCallback.getName()] === 'string') {
        callback.setInputValue(data[attibuteInputCallback.getName()])
      } else {
        callback.setInputValue(JSON.stringify(data[attibuteInputCallback.getName()]));
      }
    });
    fillStep.getCallbacksOfType(CallbackType.BooleanAttributeInputCallback).forEach(callback => {
      const attibuteInputCallback = new AttributeInputCallback(callback.payload);
      if(typeof data[attibuteInputCallback.getName()] !== 'boolean'){
        // console.log(data[attibuteInputCallback.getName()],data)
        callback.setInputValue(str2bool(data[attibuteInputCallback.getName()]))
      } else {
        callback.setInputValue(data[attibuteInputCallback.getName()])
      }
    });
    fillStep.getCallbacksOfType(CallbackType.ValidatedCreatePasswordCallback).forEach(callback => {
      const attibuteInputCallback = new AttributeInputCallback(callback.payload);
      callback.setInputValue(data[attibuteInputCallback.getPrompt()])
    })
    fillStep.getCallbacksOfType(CallbackType.TermsAndConditionsCallback).forEach(callback => {
      const attibuteInputCallback = new AttributeInputCallback(callback.payload);
      callback.setInputValue(data['termsAndConditions'])
    })

    return fillStep;
    // setStep(fillStep);
  }

  const cleanDataBeforeSubmit = (data: any) => {
    for (let key in data) {
      if (data[key] === '' || typeof data[key] === 'undefined') {
        data[key] = '';
      } else if (typeof data[key] === 'string') {
        data[key] = data[key].trim();
      } else if (typeof data[key] === 'object') {
        data[key] = cleanDataBeforeSubmit(data[key])
      }
    }
    return data;
  }

  const validateForDependentFieldSameForm = (data: any): boolean => {
    let returnValue = true;
    dependentFieldValidationMap.forEach((value: { name: string, message: string }, key) => {
      const dependentFieldValue = formContext.getValues(value.name as never) as any;
      const dataFieldValue = formContext.getValues(key as never) as any;
      if (!!dependentFieldValue) {
        if (dependentFieldValue.length) {
          /**value is Array */
          let isValid = false;
          dependentFieldValue.forEach((fieldValue: any) => {
            if (dataFieldValue.indexOf(fieldValue) > -1) {
              isValid = true;
            }
          })
          if (!isValid) {
            returnValue = false;
            formContext.setError(key as never, { message: value.message } as never, { shouldFocus: true })
          }
        } else {
          if (dataFieldValue.indexOf(dependentFieldValue) === -1) {
            returnValue = false;
            formContext.setError(key as never, { message: value.message } as never, { shouldFocus: true })
          }

        }
      }

    })
    return returnValue;
  }

  const handleSuccess = async (data: any) => {
    if (!!data.emailsToBeInvited){
      let values = data.emailsToBeInvited.split(',')
      let emailList : any[] = []
      for (let value in values) {
        emailList.push(values[value].trim())
      }
      if (emailList.length > 100) {
        setIsAlertOpen(true);
        setMessageType(MessageType.error);
        setMessage("Only 100 users can be invited at once.")
        return;
      } else {
          let emailListFinal = emailList.filter((v, i, a) => a.indexOf(v) === i)
          setDisabled(true)
          data.emailsToBeInvited = emailListFinal;
          let filledStep = fillStep(step as FRStep, data);
          let nextStep = await FRAuth.next(filledStep as FRStep, { tree });
          handleClose()
          setDisabled(false);
          setStep(nextStep);
      }
    } else {
      for( let value in data) {
        if(!isNil(data[value]))
        {
          if (value.indexOf("_sn") !== -1 || value.indexOf("_givenName") !== -1 || value.indexOf("_middleName") !== -1 || 
          value === "sn" || value === "givenName" || value === "middleName"){
            data[value] = data[value].charAt(0).toUpperCase() + data[value].slice(1)
          }
        }
      }
        setDisabled(true)
        if (!validateForDependentFieldSameForm(data)) {
          setTimeout(() => {
            setDisabled(false);
          }, 2)
          return;
        }
        let filledStep = fillStep(step as FRStep, data);
        let nextStep = await FRAuth.next(filledStep as FRStep, { tree });
        handleClose()
        setDisabled(false);
        setStep(nextStep);
      }
    
      
  }

  const handleOpen = () => {
    setIsAlertOpen(true);
  };
  const handleClose = () => {
    setIsAlertOpen(false);
  };

  const handledialogClose =()=>{
    setOpen(false)
  }

  const handleMessage = ( emails : string) => {
    let adminEmails : string[] = JSON.parse(JSON.stringify(emails))
    let uiElement: JSX.Element = <></>;
    let children: JSX.Element[] = [];
    if (adminEmails.length > 0){
      children.push(
        <div className={myResStyles.textmessage}>
          For further assistance with this company, contact client admins: 
          <br /><br />
          {!!adminEmails[0] 
            ? <a className={myResStyles.adminEmails}>{adminEmails[0]}</a> : <a className={myResStyles.adminEmails}>{"Admin not available"}</a> } (Primary) <br></br> 
          
          {!!adminEmails[0] 
            ? <a className={myResStyles.adminEmails}>{adminEmails[1]}</a> : <a className={myResStyles.adminEmails}>{"Admin not available"}</a> } (Secondary)
        </div>
      )
    }
    else {
      children.push(
        <div >
          For further assistance with this company, contact client admins: 
          <br /><br />
          {!!adminEmails[0] 
          ? <> <a style={{textDecoration:'none'}}>{adminEmails[0]}</a> (Primary) </> : <b><p>{"Admins not available"}</p></b> }   <br></br>
        </div>
      )
    }
    uiElement = <div>{children}</div>;
    setMessageToSend(uiElement);
  }

  const getStaticTextFromMeta = () => {
    let uiElement = <></>
    const staticTextJson = metaDataMap.get('$staticText')
    if (!!staticTextJson) {
      uiElement = <div style={{ marginBottom: '24px' }}>
        <h6 className={`brand-voice`} dangerouslySetInnerHTML={{ __html: staticTextJson.header }}>

        </h6>
        <ul>
          {staticTextJson.details.map((value: any) => {
            return <li><div  style={{display:"flex", justifyContent:"space-between"}}><p>{value.name + '(' + value.country + ")"} </p>
                   <p><a
          className={myResStyles.resourcestatuscontact}
          style={{ color: "#5B6376" }}
          onClick={()=> {
            handleMessage(value.contact)
            setOpen(true)
            }}
        >
          <rotor-icon name={"group"}></rotor-icon>{" "}
          {<div style={{ marginLeft: "8px", fontFamily:"Inter" }} 
            > Contact </div>}{" "}
        </a></p></div>
            </li>
          })}
        </ul>
      </div>
    }

    return uiElement;
  }

  const handleBack = async (confirmationCallBack: FRCallback, step: FRStep) => {
    setDisabled(true);

    if (step.getStage() === 'Officer' ){
      formContext.resetField('outSideForm1' as never)
      step.getCallbacksOfType(CallbackType.StringAttributeInputCallback).forEach(callback => {
        const attibuteInputCallback = new AttributeInputCallback(callback.payload);
        if (attibuteInputCallback.getName() === 'companyOfficer_email' || attibuteInputCallback.getName() === 'companyOfficer_givenName' || attibuteInputCallback.getName() === 'companyOfficer_middleName' || attibuteInputCallback.getName() === 'companyOfficer_sn'){
          callback.setInputValue(undefined)
        }
      })
    }
    step.getCallbackOfType(CallbackType.ConfirmationCallback).setInputValue(1);
    step.callbacks.forEach(callback => {
      if (viewableCallBackTypes.indexOf(callback.getType()) > -1) {
          switch(callback.getType()){
            case 'TermsAndConditionsCallback':
              callback.setInputValue(true);
              break;  
          }
         
      }
    })
    let nextStep = await FRAuth.next(step as FRStep, { tree });
    handleClose();
    setDisabled(false);
    setStep(nextStep);
  }

  const updateBottomElement = (metaDataMap:Map<string,any>) => {
    let uiElement: JSX.Element | undefined = undefined;
    let children: JSX.Element[] = []
    if (!!step && metaDataMap.size) {
      const confirmationCallbacks = step.getCallbacksOfType(CallbackType.ConfirmationCallback)
      if (!!confirmationCallbacks && confirmationCallbacks.length) {
        (confirmationCallbacks[0].getOutputValue('options') as any[]).forEach((option,index) => {
          const style:React.CSSProperties = metaDataMap.get('$confirmationCallBack')?.callbacks[index]?.style ?  metaDataMap.get('$confirmationCallBack')?.callbacks[index]?.style  : {}
          if(index ===0 ){
            // children.push(<button type={index === 0 ? 'submit' : 'button'}  disabled={isDisabled} onClick={async () => {
            // }} style={style} className={`accent-1 ${ styles.submit}`}  >{option}</button>)
            children.push(<button type={index === 0 ? 'submit' : 'button'}  disabled={isDisabled}  style={style} className={`accent-1 ${ styles.submit}`}  >{option}</button>)
          }
        })
        uiElement = <div className={styles.bottom}> {  metaDataMap.get('$confirmationCallBack')?.requiredLabel ? <span className={styles.requiredLabel}>* Required field</span> : <></>}
         <div style={{width:'100%'}}> {children}</div>
        </div>
      }
    }
      return setBottomElement(uiElement);

  }



  const updateSaveElement = () => {
    let uiElement: JSX.Element | undefined = undefined;
    let children: JSX.Element[] = []
    if (!!step) {
      const confirmationCallbacks = step.getCallbacksOfType(CallbackType.ConfirmationCallback)
      if (!!confirmationCallbacks && confirmationCallbacks.length) {
        (confirmationCallbacks[0].getOutputValue('options') as any[]).forEach((option,index) => {
          if(index ===0 && option === 'Save'){
              children.push(<button type={index === 0 ? 'submit' : 'button'}  disabled={isDisabled}  style={{width:"100%"}} className={`accent-1 ${ styles.submit}`}  >{option}</button>)
          }
        })
        uiElement = <div className={styles.bottom}> {  metaDataMap.get('$confirmationCallBack')?.requiredLabel ? <span className={styles.requiredLabel}>* Required field</span> : <></>}
         <div style={{width:'100%'}}> {children}</div>
        </div>
      }
    }
    return setBottomElement(uiElement);
  }

  const updateBackButtonElement = (metaDataMap:Map<string,any>) => {
    let uiElement: JSX.Element | undefined = undefined;
    let children: JSX.Element[] = []
    if (!!step && metaDataMap.size) {
      const confirmationCallbacks = step.getCallbacksOfType(CallbackType.ConfirmationCallback)
      if (!!confirmationCallbacks && confirmationCallbacks.length) {
        (confirmationCallbacks[0].getOutputValue('options') as any[]).forEach((option,index) => {
          if(index === 1){
            children.push(
            <button type={'button'}  disabled={isDisabled} onClick={async () => {handleBack(confirmationCallbacks[0], step) }} className={styles.backButton}  >
              <div className={styles.backButtonText}>
                <div><b>{"<-"}</b></div><div>{option}</div>
              </div>
            </button>)
          }
          
        })
        uiElement = <div style={{width:'100%'}}> {children}</div>
      }
    }
      return setBackBottomElement(uiElement);

  }
  

const getSubHeaderText=()=>{
      if(!!(step.getDescription()) && step.getDescription()?.trim()!==''){
        return step.getDescription()
      }else{
        return getTextOutputCallBackByMessageType(step,'0')?.getOutputByName("message",'Enter One Time Password sent to your email')
      }
  }

  //  -----------------END METHODS-----------------------------------


  return (
    <>
      <SuccessErrorModal
        type={MessageType.dialog}
        open={open}
        handleClose={handledialogClose}
        style={modalStyle}
        title={"Resource support"}
        messageHTML={messageToSend}
      />

      <CustomFormContainer
        defaultValues={{}}
        formContext={formContext}
        onSuccess={handleSuccess}
      >
        <SuccessErrorModal
          open={isAlertOpen}
          type={messageType}
          handleClose={handleClose}
          message={message}
        />
        <FormLayout
          header={step.getHeader()}
          subHeader={getSubHeaderText()}
          backButton={backBottomElement}
          button={bottomElement}
          backLink={backLink}
          disabled={isDisabled}
        >
          <>
            {getStaticTextFromMeta()}
            {getUIElements(step)}
          </>
        </FormLayout>
      </CustomFormContainer>
    </>
  );
}